import range from 'lodash/range';

import * as Types from 'core/ovations-api/definitions';
import * as Enums from 'core/ovations-api/enums';

const rewardCalculation: Types.StaticPointsRewardCalculation = {
    id: 1,
    type: Enums.RewardCalculationType.StaticPoints,
    label: null,
    points: 42,
    rewardPackages: [],
    alternatePayeeRewardPackageId: null,
    alternatePayeeRewardPackageType: null,
    rewardPackageName: '',
    sortOrder: 0,
};

export const mockSalesIncentives: Types.SalesIncentive[] = range(1, 5).map((i) => ({
    id: String(i),
    number: i,
    name: `Mock Sales Incentive ${i}`,
    salesStart: '2018-10-08T12:00:00.000Z',
    salesEnd: '2018-10-09T12:00:00.000Z',
    state: Object.keys(Enums.SalesIncentiveState)[i % 5] as Enums.SalesIncentiveState,
    programId: `programId-${i}`,
    ownerName: '',
    calculationType: Enums.SalesIncentiveCalculationType.PerUnit,
    contactNumber: '',
    contactName: '',
    contactEmail: '',
    estimatedRedemptions: null,
    poBox: '',
    poNumber: '',
    suiteNumber: '',
    callCenterTollFreeNumber: '',
    requiresPrefunding: false,
    rewardCalculation,
    totalQuantity: undefined,
}));

export const mockSalesIncentive = mockSalesIncentives[0];
